export class MergeFieldInfo {
  defaultValue: string;
  fieldName: string;

  constructor(info?: any) {
    info = info || {};
    this.defaultValue = info.defaultValue || null;
    this.fieldName = info.fieldName || null;
  }
}
